import { Reducer } from "../../lib/redux";
import { extend } from "../../utils/vanilla";
import { actions } from "./actions";
import { UserActionTypes } from "./types";

export let defaultUsers: IIdDictionary<IUser> = {};

export let users: Reducer<IIdDictionary<IUser>, actions> = (state = defaultUsers, action) => {
        switch (action.type) {
                case UserActionTypes.SET_USERS:
                        return extend(true, {}, action.payload);
                case UserActionTypes.CLEAR_USERS:
                        return defaultUsers;
                default:
                        return state;
        }
};
